module.exports = __webpack_public_path__ + "media/images/home/just_eats-2922680dd864df36cec5c5763d000eb9.png";